import {useQuery} from 'react-query';
import {getMahsul} from 'services/products';

const useGetMahsuls = (guid: string) => {
  const {data, isLoading} = useQuery(['products', guid], getMahsul);
  return {products: data, isLoading};
};

export default useGetMahsuls;
